<template>
  <div class="lamp-content">
    <el-transfer
      filterable
      :data="allDevices"
      :titles="['未分配的屏幕', '已分配的屏幕']"
      :button-texts="['从列表删除', '添加到列表']"
      v-model="allocated"
      @change="dataChange"
    >
    </el-transfer>
    <br />
    <el-button type="primary" @click="cancel">返回</el-button>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import screenApi from "@/api/message/screenList"
export default {
  name: "sendprogram",
  props: {
    sendData: {
      type: Object
    },
  },
  data() {
    return {
      allDevices: [],
      allocated: []
    }
  },
  methods: {
    dataChange(value) {
      if(value.length){
        let valueStr = value.toString()
        let params = {
          id: this.sendData.id,
          deviceCode: valueStr
        }
        axios({
          url: process.env.VUE_APP_BASE_API+'/v1/programGuides/manager/updateProgramData',
          method: 'post', 
          data: qs.stringify(params)
        }).then(res => {
          if (res.data.code === 1000) {
            this.$message.success(res.data.message);
            this.$emit('closeMethod')
          } else {
            this.$message.error(res.data.message);
          }
        })
      }
    },
    getAllDevices() { // 获取所有屏幕
      screenApi.screenList({
        // ste: 1,
        page: 1,
        pageSize: 2000
      }).then((res) => {
        if (res.data.code === 1000) {
          for (const device of res.data.data.list) {
            this.allDevices.push({
              key: device.number,
              label: device.name
            })
          }
          this.getAllocated()
        }
      });
    },
    getAllocated() { // 获取该节目单下的所有屏幕
      let deviceCode = this.sendData.deviceCode
      let deviceCodeArr = []
      if(deviceCode){
        deviceCodeArr = deviceCode.split(',')
      }
      this.allocated = deviceCodeArr
    },
    cancel() {
      this.$emit('closeMethod')
    }
  },
  created() {
    this.getAllDevices()
  }
}
</script>
